module.exports = "<ng-content select=\"[itpx-editor-toolbar]\"></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/controls/html-editor/html-editor.component.html
// module id = ./src/app/shared/components/controls/html-editor/html-editor.component.html
// module chunks = main